import { createApp } from 'vue';
import WordToPdfAConverter from '../Components/WordToPdfAConverter.vue';

const root = document.getElementById('word-to-pdfa-converter');
if (root) {
    createApp(WordToPdfAConverter).mount('#word-to-pdfa-converter');
}
